module.exports = __webpack_public_path__ + "img/cuestionario.a4590486.png";